import { MenuItem, TextField, TextFieldProps } from '@mui/material';
import { FunctionComponent, ReactElement, ReactNode, UIEvent } from 'react';

const ITEM_HEIGHT = 36;
const ITEM_PADDING_TOP = 8;
const DEFAULT_ITEMS_COUNT = 8;

export interface SelectInputOption {
	value?: string;
	label: ReactNode;
}

export type SelectInputProps = {
	options?: SelectInputOption[];
	moreOptionsLoadingIndicator?: ReactElement;
	itemCount?: number;
	onScroll?: () => void;
} & TextFieldProps;

const SelectInput: FunctionComponent<SelectInputProps> = ({
	options,
	children,
	moreOptionsLoadingIndicator,
	itemCount = DEFAULT_ITEMS_COUNT,
	onScroll,
	...rest
}): ReactElement => {
	const menuProps = {
		PaperProps: {
			style: {
				maxHeight: ITEM_HEIGHT * itemCount + ITEM_PADDING_TOP,
			},
			onScroll: (event: UIEvent<HTMLElement>) => {
				if (
					event.currentTarget.scrollHeight - event.currentTarget.scrollTop ===
					event.currentTarget.clientHeight
				) {
					onScroll?.();
				}
			},
		},
	};

	return (
		<TextField select SelectProps={{ ...rest.SelectProps, MenuProps: menuProps }} {...rest}>
			{options?.map(({ value, label }) => (
				<MenuItem key={value} value={value}>
					{label}
				</MenuItem>
			))}
			{moreOptionsLoadingIndicator}
		</TextField>
	);
};

export default SelectInput;
